import { merge } from "lodash";
import { IVariaveisAmbiente, IAmbienteUnico } from "./types";

const AmbienteEnviado = (process.env.REACT_APP_ENV || "mpProd") as keyof IVariaveisAmbiente;
const AmbientePadrao: keyof IVariaveisAmbiente = AmbienteEnviado;
const LabelEnviado = (process.env.REACT_APP_LABEL || "Touchone") as keyof IVariaveisAmbiente;

 const apiUrl = 'https://api-pedidos-prod.saurus.net.br';
 const apiHomoUrl = 'https://api-pedidos-staging.saurus.net.br';

const _variaveisAmbiente: IVariaveisAmbiente = {
  all: {
    version: "1.0.0",
    isDev: (["prodWeb"].find(x => x === AmbientePadrao.toString())?.length || 0) === 0,
    environment: AmbienteEnviado,
    googleAppId: "27279191635-5kdincvmbm92lihatr0k4tm1o4kon8ue.apps.googleusercontent.com",
    saurusUtilsWebService: "https://wsmaster.saurus.net.br/v003/servicemaster.asmx",
    label: LabelEnviado,
    apiMasterUrl: "https://apisaurusgestao-master.azurewebsites.net",
  },
  devWeb: {
    apiUrl,
    apiHomoUrl,
    facebookAppId: "661218711269424",
    frontUrl: "http://localhost:3000",
    isSlowDevice: false,
  },
  prodWeb: {
    apiUrl,
    apiHomoUrl,
    facebookAppId: "1880946222051906",
    frontUrl: "https://app.touchone.com.br",
    isSlowDevice: false,
  },
};

const _ambienteUnico =
  (_variaveisAmbiente[AmbientePadrao] as IAmbienteUnico) || _variaveisAmbiente.devWeb;
export const VariaveisAmbiente = merge(_variaveisAmbiente.all, _ambienteUnico);
